import styled from 'styled-components'

import { LinkDeleteUnstyled } from 'Components/LinkDelete/unstyled'

export const LinkDelete = styled(LinkDeleteUnstyled)`
  display: block;
  float: left;
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 4px;
  cursor: pointer;

  svg {
    position: absolute;
    height: 100%;
    width: 14px;
    fill: ${props => props.theme.colors.regentGray};
    left: 0;
    right: 0;
    margin: auto;
  }
`
